import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const sisenseChartPlugin = createPlugin({
  id: 'sisense-chart',
  routes: {
    root: rootRouteRef,
  },
});

export const SisenseSolutionPage = sisenseChartPlugin.provide(
  createRoutableExtension({
    name: 'SisenseSolutionPage',
    component: () =>
      import('./components/SisenseSolution').then(
        m => m.SisenseSolution as (props: any) => JSX.Element | null,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const SisenseTeamPage = sisenseChartPlugin.provide(
  createRoutableExtension({
    name: 'SisenseTeamPage',
    component: () =>
      import('./components/SisenseTeam').then(
        m => m.SisenseTeam as (props: any) => JSX.Element | null,
      ),
    mountPoint: rootRouteRef,
  }),
);
